import React, {PropTypes} from 'react';
import {Modal} from 'react-overlays';
import Button from '../common/Button';
import '../../styles/modals/confirmActionModal.css';

const ConfirmationModal = ({modalShown, onHide, onConfirm, confirmTitle, confirmText, confirmButtonText, cancelButtonText}) => {

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 'auto',
    backgroundColor: '#000',
    opacity: 0.5
  };
  return (
    <Modal
      className="confirm-action-modal"
      backdropStyle={backdropStyle}
      show={modalShown}
      onHide={onHide}>
      <div className="confirm-action-modal-dialog">
        <div className="confirm-action-modal-text">
          <h3>{confirmTitle}</h3>
          {confirmText}
        </div>
        <div className="confirm-action-modal-buttons non-mobile">
          <Button
            onClick={onConfirm}
            className=" generate-new-token pull-right"
            value={confirmButtonText}
            disabled={false}/>
          <a className="btn btn-cancel pull-right" onClick={onHide}>
            {cancelButtonText}
          </a>
        </div>
        <div className="confirm-action-modal-buttons mobile">
          <div className="confirm-action-modal-cancel">
            <a onClick={onHide}>
              {cancelButtonText}
            </a>
          </div>
          <Button
            onClick={onConfirm}
            className="outlined-button confirm-button pull-right"
            value={confirmButtonText}
            disabled={false}/>
        </div>
      </div>
    </Modal>
  );
};
ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmTitle: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired
};

export default ConfirmationModal;


/** WEBPACK FOOTER **
 ** ./src/components/establishment/ConfirmationModal.js
 **/